module.exports = __webpack_public_path__ + "img/selected0-min.05ed1312.png";